import { faBoxArchive } from "@fortawesome/free-solid-svg-icons/faBoxArchive";
export let iconProject = faBoxArchive;
export function overwriteProject(icon) {
    iconProject = icon;
}
export default iconProject;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicHJvamVjdC5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uL3NyYy9wcm9qZWN0LnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUNBLE9BQU8sRUFBRSxZQUFZLEVBQUUsTUFBTSxnREFBZ0QsQ0FBQztBQUU5RSxNQUFNLENBQUMsSUFBSSxXQUFXLEdBQUcsWUFBWSxDQUFDO0FBRXRDLE1BQU0sVUFBVSxnQkFBZ0IsQ0FBQyxJQUFvQjtJQUNuRCxXQUFXLEdBQUcsSUFBSSxDQUFDO0FBQ3JCLENBQUM7QUFFRCxlQUFlLFdBQVcsQ0FBQyJ9